
<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="Reports" :icon="require('@/assets/admin-icon/reports-active.svg')">
        <div class="options"></div>
      </WidgetToolbar>
    </div>

    <div class="page-body">
      <div class="overview-widget" v-show="report_data">
        <div class="chart">
          <div class="chart-header">
            <h2>Students with LIAs per Class</h2>
          </div>
          <div class="chart-body">
            <apexchart width="100%" height="100%" type="bar" ref="class_chart" :options="school_class_matched_chart"
              :series="school_class_matched_chart.series"></apexchart>
          </div>
        </div>
        <div class="chart-body-divider"></div>
        <div class="chart">
          <div class="chart-header">
            <h2>Students with Confirmed LIAs ( Signed Contract ) per Class</h2>
          </div>
          <div class="chart-body">
            <apexchart width="100%" height="100%" type="bar" ref="signed_contract_chart"
              :options="school_class_signed_chart" :series="school_class_signed_chart.series"></apexchart>
          </div>
        </div>

        <!-- <div class="chart">
          <div class="chart-header">
            <h2>Students with LIAs per School</h2>
          </div>
          <div class="chart-body">
            <apexchart
              width="100%"
              :height="`500px`"
              type="bar"
              ref="department_chart"
              :options="school_department_chart"
              :series="school_department_chart.series"
            ></apexchart>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Overview",
  components: {},
  data() {
    return {
      school_class_matched_chart: {
        colors: ["#E59116", "#4E4D4D", "#007D7C"],
        chart: {
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            columnWidth: 60,
            barHeight: "50%",
            distributed: true,
            rangeBarOverlap: false,
            rangeBarGroupRows: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: undefined,
                },
              ],
              backgroundBarColors: [],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0,
            },
            dataLabels: {
              position: "bottom",
              maxItems: 100,
              hideOverflowingLabels: true,
              orientation: "horizontal",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        yaxis: {
          tickAmount: 5,
          max: 100,
          labels: {
            formatter: (value) => {
              return value + "%";
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            minWidth: 0,
            maxWidth: 500,
            align: "right",
            rotate: 0,
          },
        },
        series: [
          {
            name: "Students",
            data: [],
          },
        ],
      },
      school_class_signed_chart: {
        colors: ["#E59116", "#4E4D4D", "#007D7C"],
        chart: {
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            columnWidth: 60,
            barHeight: "50%",
            distributed: true,
            rangeBarOverlap: false,
            rangeBarGroupRows: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: undefined,
                },
              ],
              backgroundBarColors: [],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0,
            },
            dataLabels: {
              position: "bottom",
              maxItems: 100,
              hideOverflowingLabels: true,
              orientation: "horizontal",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        yaxis: {
          tickAmount: 5,
          max: 100,
          labels: {
            formatter: (value) => {
              return value + "%";
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            minWidth: 0,
            maxWidth: 500,
            align: "right",
            rotate: 0,
          },
        },
        series: [
          {
            name: "Students",
            data: [],
          },
        ],
      },
      school_department_chart: {
        colors: ["#E59116", "#4E4D4D", "#007D7C"],
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
              pan: false,
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 0,
            columnWidth: 60,
            barHeight: "100%",
            distributed: true,
            rangeBarOverlap: false,
            rangeBarGroupRows: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: undefined,
                },
              ],
              backgroundBarColors: [],
              backgroundBarOpacity: 1,
              backgroundBarRadius: 0,
            },
            dataLabels: {
              position: "bottom",
              maxItems: 100,
              hideOverflowingLabels: true,
              orientation: "horizontal",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        yaxis: {
          max: 100,
          tickAmount: 5,
          labels: {
            formatter: (value) => {
              return value + "%";
            },
          },
        },
        xaxis: {
          categories: [],
          labels: {
            minWidth: 0,
            maxWidth: 500,
            align: "right",
            rotate: 0,
          },
        },
        series: [
          {
            name: "Students",
            data: [],
          },
        ],
      },
      report_data: {
        teams: {
          labels: [],
          data: [],
        },
        students: {
          labels: [],
          data: [],
        },
      },
      chart_width: 300,
      loading_char_data: false,
    };
  },

  methods: {
    getReportData() {
      let vm = this;
      vm.loading_char_data = true;
      vm.$store
        .dispatch("REPORT_GET_ALL")
        .then((response) => {
          vm.report_data = response.data;
          vm.loadSchoolClassReport();
          vm.loadSchoolContractReport();
          vm.loadSchoolDepReport();
          vm.loading_char_data = false;
        })
        .catch((error) => {
          vm.loading_char_data = false;
          console.error({ error });
        });
    },
    loadSchoolContractReport() {
      let vm = this;
      if (vm.report_data.contract_signed) {
        let chart_data = vm.report_data.contract_signed.values.map((item) => {
          return parseInt(item);
        });
        let chart_width =
          (2000 * vm.report_data.contract_signed.labels.length) / 18;
        vm.$refs.signed_contract_chart.updateSeries(
          [
            {
              data: chart_data,
            },
          ],
          false,
          true
        );
        vm.$refs.signed_contract_chart.updateOptions({
          chart: {
            width: chart_width + "px",
            height: "100%",
          },
          plotOptions: {
            bar: {
              barHeight: (100 * chart_data.length) / 50 + "%",
            },
          },
          xaxis: {
            categories: vm.report_data.contract_signed.labels.map((item) => {
              return item.split(" ");
            }),
          },
        });
      }
    },
    loadSchoolClassReport() {
      let vm = this;

      let chart_data = vm.report_data.teams.values.map((item) => {
        return parseInt(item);
      });

      let chart_width = (2000 * vm.report_data.teams.labels.length) / 18;

      vm.$refs.class_chart.updateSeries(
        [
          {
            data: chart_data,
          },
        ],
        false,
        true
      );
      vm.$refs.class_chart.updateOptions({
        chart: {
          width: chart_width + "px",
          height: "100%",
        },
        plotOptions: {
          bar: {
            barHeight: (100 * chart_data.length) / 50 + "%",
          },
        },
        xaxis: {
          categories: vm.report_data.teams.labels.map((item) => {
            return item.split(" ");
          }),
        },
      });
    },
    loadSchoolDepReport() {
      let vm = this;
      let chart_data = vm.report_data.departments.values.map((item) => {
        return parseInt(item);
      });
      let chart_width = (2000 * vm.report_data.teams.labels.length) / 18;
      vm.$refs.department_chart.updateSeries(
        [
          {
            data: chart_data,
          },
        ],
        false,
        true
      );
      vm.$refs.department_chart.updateOptions({
        chart: {
          width: chart_width + "px",
          height: "100%",
        },
        plotOptions: {
          bar: {
            barHeight: (100 * chart_data.length) / 50 + "%",
          },
        },
        xaxis: {
          categories: vm.report_data.departments.labels.map((item) => {
            return item.split(" ");
          }),
        },
      });
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.getReportData();
  },
  created() {
    Array.prototype.max = function () {
      return Math.max.apply(null, this);
    };

    Array.prototype.min = function () {
      return Math.min.apply(null, this);
    };
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;

    }
  }

  .page-body {
    height: calc(100% - 43px);
    display: flex;
    flex-direction: column;
    padding-top: 5px;

    .overview-widget {
      display: flex;
      height: 100%;

      .chart-body-divider {
        margin-left: 5px;
        height: 100%;
      }

      .chart {
        justify-content: space-between;
        width: calc(50% - 5px);
        height: 100%;
        background: #fff;
        border-radius: 5px;
        display: flex;
        flex-direction: column;

        .chart-header {
          margin-left: 15px;
          height: 65px;
          display: flex;
          align-items: center;

          h2 {
            font-size: 14px;
          }
        }

        .chart-body {
          height: calc(100% - 65px);
          overflow-x: auto;
          overflow-y: hidden;
        }
      }
    }
  }
}
</style>
